
export function filterDropdown(id) {
    let input, filter, a, i, txtValue;
    let currentWorkingElement = [];
    input = document.getElementById(id);
    filter = input.value.toUpperCase();
    let div = document.getElementsByClassName("bx--list-box__wrapper");
    currentWorkingElement = Array.prototype.filter.call(
        div,
        function(el) {return el.getAttribute('aria-expanded') === 'true';}
       );
    if(currentWorkingElement.length) {
        a = currentWorkingElement[0].getElementsByClassName("bx--list-box__menu-item");
        for (i = 0; i < a.length; i++) {
            txtValue = a[i].textContent || a[i].innerText;
            if (txtValue.toUpperCase().indexOf(filter) > -1) {
                a[i].style.display = "";
            } else {
                a[i].style.display = "none";
            }
        }
    }
}